
import http, { HttpSuccessOrErrorType } from '../http';
import { ResultSetHeader, GybDevice, Condition } from '../../models';

export default {
    /**
     * 设置GYB默认设备
     * @param params 参数
     */
    async patch_restaurant_string_id_gyb_device_default(params: { string_id: string, device_code: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, device_code } = params;
        return await http.patch(`restaurant/${string_id}/gyb_device/default/${device_code} `)
    },

    /**
     * 根据所属餐厅string_id，条件查询gybDevice。
     * @param params 参数
     */
    async get_restaurant_string_id_gyb_device_condition(params: { string_id: string } & GybDevice & Condition): Promise<HttpSuccessOrErrorType<Array<GybDevice>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/gyb_device/condition`, {
            params: {
                ...rest
            }
        })
    },
}